import ShareAuth from '@sagano/share/vendors/firebase';
import { auth } from '@sagano/train/stores';

const trainAuth = new ShareAuth(auth);

export default trainAuth;
